import React, { forwardRef, memo, ForwardedRef } from 'react';
import Button from 'components/Button/Button';
import styles from './AddToBasketButton.module.css';

interface Props {
  handleAddToBasket: () => void;
  disabled: boolean;
  updateBasket?: boolean;
}

const AddToBasketButton = forwardRef(
  ({ handleAddToBasket, disabled, updateBasket = false }: Props, ref: ForwardedRef<HTMLDivElement>) => (
    <div ref={ref} className={styles.container}>
      <Button
        id="primaryAddToBasket"
        onClick={() => handleAddToBasket()}
        data-testid="add_to_basket_button"
        disabled={disabled}
        size="large"
        data-transaction-name={updateBasket ? 'UpdateBasket' : 'AddToBasket'}
      >
        {updateBasket ? 'Update basket' : 'Add to basket'}
      </Button>
    </div>
  ),
);

export default memo(AddToBasketButton);
